import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'home',
			component: () => import('./views/home.vue')
		},
		{
			path: '/business',
			name: 'business',
			component: () => import('./views/business.vue')
		},
		{
			path: '/student',
			name: 'student',
			component: () => import('./views/student.vue')
		},
		// Internal
		{
			path: '/crossfit',
			name: 'crossfit',
			component: () => import('./views/crossfit.vue')
		},
		{
			path: '/futbol',
			name: 'futbol',
			component: () => import('./views/futbol.vue')
		},
		{
			path: '/danza',
			name: 'danza',
			component: () => import('./views/danza.vue')
		},
		{
			path: '/yoga',
			name: 'yoga',
			component: () => import('./views/yoga.vue')
		},
		{
			path: '/defensa',
			name: 'defensa',
			component: () => import('./views/defensa.vue')
		}
	]
	,
	scrollBehavior () {
		return new Promise(resolve => {
			setTimeout(() => {
				resolve({ x: 0, y: 0 })
			}, 350)
		})
	}
})
